import type { AgentIntroProps } from './AgentIntro';
import { CATEGORY_COLORS } from '@/shared/constants/category-colors';
import { ToolIconsV4 } from '@/shared/ui/GeneralIcons/GeneralIcons.v4';
import { ToolBadge } from '@/shared/ui/ToolBadge';

/** Tile colour for an agent that belongs to no category. */
const FALLBACK_TAG_BACKGROUND = 'var(--primary)';

/** An agent's icon and its tile colour, from its category when it has one. */
export function agentIntroLook(
  agentId: string,
  category: string | undefined,
): Pick<AgentIntroProps, 'icon' | 'tagBackground'> {
  if (category && category in CATEGORY_COLORS) {
    return { icon: <ToolBadge toolId={agentId} category={category} size="2xl" /> };
  }
  // eslint-disable-next-line i18next/no-literal-string -- a category id, not copy
  return { icon: ToolIconsV4(agentId, 'deliver', 24), tagBackground: FALLBACK_TAG_BACKGROUND };
}
